import { useRef, useCallback, useEffect } from 'react';
import { useAuth } from 'providers/AuthProvider';

const useAccountLockout = () => {
  const timeoutRef = useRef();
  const { logout } = useAuth();

  const triggerAccountLockout = useCallback(
    (after = 5000) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => logout(), after);
    },
    [logout]
  );

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return { triggerAccountLockout };
};

export default useAccountLockout;
